import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Observable, Subject } from 'rxjs';

import {
  AddUpdateUtenteCommand,
  GetCommand,
  SelectCommand,
  SendEmailCommand,
} from '../model/command-model';
import {
  GoToModel,
  ListMieiGruppiStudioDTO,
  ListRisultatoProvaFinaleDTO,
  ListSelectDTO,
  SelectDTO,
  SessioneOlaDTO,
} from '../model/newModel';
import { ConstantsCLA } from './constants-cla';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  eventEvent = new Subject<any>();
  actionYESEvent = new Subject<any>();
  force = false;
  constructor(
    private http: HttpClient,
    public router: Router,
    public ngxSmartModalService: NgxSmartModalService
  ) {}

  generaAttestato(idStudente, idSessioneOla) {
    const command = {
      idStudente,
      idSessioneOla,
    };
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({}),
    };

    return this.http.post<any>(
      ConstantsCLA.DOWNLOAD_ATTESTATO_STUDENTE,
      command,
      httpOptions
    );
  }

  setForceRegister(force: boolean) {
    this.force = force;
  }

  getForceRegister() {
    return this.force;
  }

  getMieiGruppiStudio(idInstructor: number) {
    const command = new GetCommand();
    command.id = idInstructor;

    return this.http.post<ListMieiGruppiStudioDTO>(
      ConstantsCLA.I_MIEI_GRUPPI_STUDIO_URL,
      command
    );
  }

  getRegistrazioneSistemaAttuale() {
    const command = new GetCommand();
    command.id = 1;
    return this.http.post<boolean>(
      ConstantsCLA.GET_REGISTRAZIONE_SISTEMA_URL,
      command
    );
  }

  selectCorsiLaurea() {
    const command = new SelectCommand();
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.CORSI_LAUREA_COMBO_URL,
      command
    );
  }

  selectSessioniOla(active: boolean) {
    const command = new SelectCommand();
    command.active = active ? active : null;
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.SESSIONI_OLA_COMBO_URL,
      command
    );
  }

  selectTutors() {
    const command = new SelectCommand();
    command.active = true;
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.TUTORS_COMBO_URL,
      command
    );
  }

  selectLaboratori() {
    const command = new SelectCommand();
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.LABORATORI_COMBO_URL,
      command
    );
  }

  getTotaleAgendeDaVerificare() {
    const command = new GetCommand();
    return this.http.post<number>(
      ConstantsCLA.GET_AGENDE_DA_VERIFICARE,
      command
    );
  }

  getSessioneOlaActive() {
    const command = new SelectCommand();
    return this.http.post<SessioneOlaDTO>(
      ConstantsCLA.SESSIONE_OLA_ACTIVE_URL,
      command
    );
  }

  selectInstructorsAttivi() {
    const command = new SelectCommand();
    command.active = true;
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.INSTRUCTORS_COMBO_URL,
      command
    );
  }

  selectStudentiIdonei() {
    const command = new SelectCommand();
    command.idoneo = true;
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.STUDENTI_COMBO_URL,
      command
    );
  }

  selectGiorniSettimana() {
    const command = new SelectCommand();
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.GIORNI_SETTIMANA_COMBO_URL,
      command
    );
  }

  update(command: AddUpdateUtenteCommand) {
    return this.http.post<Boolean>(ConstantsCLA.MODIFICA_URL, command);
  }

  getFotoProfilo(id: number): Observable<any> {
    const command = new GetCommand();
    command.id = id;
    return this.http.post(ConstantsCLA.GET_FOTO_PROFILO_URL, command, {
      responseType: 'blob' as 'json',
    });
  }

  sendEmail(sendEmail: SendEmailCommand) {
    return this.http.post<Boolean>(ConstantsCLA.SEND_EMAIL_URL, sendEmail);
  }

  allSelectTipologieAbilitatoDisabilitato(): SelectDTO[] {
    const tipologie = [];
    const allTypes = new SelectDTO();
    allTypes.value = 'ALL';
    allTypes.viewValue = 'TUTTI I TIPI';

    const disabilitati = new SelectDTO();
    disabilitati.value = 'DISATTIVATI';
    disabilitati.viewValue = 'DISABILITATI';

    const abilitati = new SelectDTO();
    abilitati.value = 'ATTIVI';
    abilitati.viewValue = 'ABILITATI';

    tipologie.push(allTypes);
    tipologie.push(disabilitati);
    tipologie.push(abilitati);

    return tipologie;
  }

  goTo(goToModel: GoToModel) {
    this.router.navigate([goToModel.url], {
      queryParams: {
        goBack: JSON.stringify(goToModel),
        date: new Date().getTime(),
      },
    });
  }

  downloadDocument(idDocument: number) {
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({}),
    };
    const command = new GetCommand();
    command.id = idDocument;

    return this.http.post<any>(
      ConstantsCLA.DOWNLOAD_DOCUMENT_SESSIONE_OLA,
      command,
      httpOptions
    );
  }

  openStoricoProvaFinaleModal(
    list: ListRisultatoProvaFinaleDTO,
    orale: boolean
  ): void {
    let data;
    if (orale) {
      data = {
        listStorico: list.storicoOrale,
      };
    } else {
      data = {
        listStorico: list.storicoScritto,
      };
    }
    this.ngxSmartModalService
      .getModal('storicoProvaFinaleModalComponent')
      .removeData();
    this.ngxSmartModalService.setModalData(
      data,
      'storicoProvaFinaleModalComponent'
    );
    this.ngxSmartModalService
      .getModal('storicoProvaFinaleModalComponent')
      .open();
  }

  openWarningModal(text: string): void {
    this.ngxSmartModalService.getModal('warningModal').removeData();
    this.ngxSmartModalService.setModalData(text, 'warningModal');
    this.ngxSmartModalService.getModal('warningModal').open();
  }

  openAnswerModal(text: string): void {
    this.ngxSmartModalService.getModal('answerModal').removeData();
    this.ngxSmartModalService.setModalData(text, 'answerModal');
    this.ngxSmartModalService.getModal('answerModal').open();
  }

  openOkModal(text?: string): void {
    this.ngxSmartModalService.getModal('okModal').removeData();
    if (text) {
      this.ngxSmartModalService.setModalData(text, 'okModal');
    }
    this.ngxSmartModalService.getModal('okModal').open();
  }

  openKoModal(): void {
    this.ngxSmartModalService.getModal('koModal').open();
  }

  closeAnswerModal(): void {
    this.ngxSmartModalService.getModal('answerModal').close();
  }
}
